import basePropertyOf from './_basePropertyOf.js';

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

export default escapeHtmlChar;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_escapeHtmlChar.js
// module id = 1221
// module chunks = 0